import React, {useEffect, useState} from "react";
import { Form } from "react-bootstrap";
const { REACT_APP_BACKEND_URL } = process.env;


const ConsentSigningBoldSign = ({token, data}) => {
  const[templateName, setTemplateName] = useState("Loading...");
  const[signingUrl, setSigningUrl] = useState(null);
  const[signingUrlIndex, setSigningUrlIndex] = useState(0);
  const[hasMore, setHasMore] = useState(false);

  const BOLDSIGN_ORIGIN = "https://app.boldsign.com";

  async function completeSigning() {
    const requestMetadata = {
      method: 'POST',
    };

    const res = await fetch(REACT_APP_BACKEND_URL + "consent/" + token, requestMetadata);

    if (res.status >= 200 && res.status <= 299)
    {
      window.location.reload();
    }
    else
    {
      throw Error(res.statusText);
    }
  }

  async function getNextDocument(currentUrlIndex) {
    const res = await fetch(REACT_APP_BACKEND_URL + "consent/" + token, {
      method: "GET",
      headers: { requestedUrlIndex: currentUrlIndex + 1 },
    });

    if (res.status === 200) 
    {
      const result = await res.json();
      if (result.url != null && result.urlIndex > 0) 
      {
        setTemplateName(result.templateName);
        setSigningUrl(result.url);
        setSigningUrlIndex(result.urlIndex);
        setHasMore(result.hasMore);
      }
      else if (result.url === null && result.hasMore)
      {
        getNextDocument(result.urlIndex);  // Skip if already signed
      } 
      else 
      {
        completeSigning();
      }
    } 
    else 
    {
      alert("Error getting next document");
    }
  }


  useEffect(() => {
    if (data && data["hasMore"] !== undefined)  // Make sure it's loaded
    {
      if (data.url != null && data.urlIndex >= 0)
      {
        setTemplateName(data.templateName);
        setSigningUrl(data.url);
        setSigningUrlIndex(data.urlIndex);
        setHasMore(data.hasMore);
      }
      else if (data.url === null && data.hasMore)
      {
        getNextDocument(data.urlIndex);  // Skip if already signed
      }
      else
      {
        // Go straight to success
        completeSigning();
      }
    }

  }, [token, data]);

    // Register BoldSign message listener — re-registers whenever signingUrl changes
  useEffect(() => {
    if (!signingUrl) return;

    function handleMessage(event) {
      if (event.origin !== BOLDSIGN_ORIGIN) return;

      switch (event.data.action) 
      {
        case "onDocumentSigned":
          if (hasMore) {
            getNextDocument(signingUrlIndex);
          } else {
            completeSigning();
          }
          break;
        case "onDocumentSigningFailed":
          alert("Signing failed, please try again.");
          break;
        default:
          break;
      }
    }

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);  // cleanup on next render

  }, [signingUrl, signingUrlIndex, hasMore]);  // fresh closure each time these change


  var divWidth = (!window.innerWidth || window.innerWidth >= 800) ? 700 : parseInt(window.innerWidth * .7);
  var divHeight = Math.min(parseInt(divWidth * 1.9), 1050);

  return (
    <>
      <Form.Label style={{fontWeight: "bold"}}>E-Signature: {templateName}</Form.Label>
      <br /><br />
      <div style={{height: divHeight + "px", width: divWidth + "px"}}>
        {signingUrl &&
        <iframe src={signingUrl} key={signingUrlIndex} title="Document Signing" style={{height: "100%", width: "100%", border: "none"}} />
        }
      </div>
    </>

  );
}

export default ConsentSigningBoldSign;
